"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _intlLoaders = _interopRequireDefault(require("./intlLoaders"));

var _translationsLoaders = _interopRequireDefault(require("./translationsLoaders"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable global-require, import/no-named-as-default */
var permitParams = function permitParams(callback) {
  if (typeof callback !== 'function') {
    throw new Error('Second argument must be function');
  }
};

var _default = function _default(locale, callback, scope) {
  permitParams(callback);

  if (!global.Intl) {
    require('intl');
  }

  if (global.IntlPolyfill) {
    (0, _intlLoaders.default)(locale);
  }

  (0, _translationsLoaders.default)(locale, callback, scope);
};
/* eslint-enable global-require, import/no-named-as-default */


exports.default = _default;